import Link from "next/link";
import { motion } from "framer-motion";
import AnimatedBody from "../animations/AnimatedBody.tsx";
import React from "react";

const Footer = () => {
    return (
        <motion.section
            className="flex w-full items-center justify-center bg-[#0E1016] px-4 py-6 font-bold uppercase sm:py-8 md:py-10 lg:py-8"
            initial="initial"
            animate="animate"
        >
            <motion.div className="mx-auto flex w-full max-w-[90%] flex-col items-center justify-center gap-2 text-center text-[11px] text-[#e4ded7] sm:text-[12px] md:flex-row md:justify-between md:text-[14px] lg:max-w-[1440px]">
                <AnimatedBody
                    text={"© Neil Broneer 2025"}
                    className={"m-0 p-0"}
                />
            </motion.div>
        </motion.section>
    );
};

export default Footer;
